export const UserState = {
    VALIDATE: 'VALIDATE',
    CREATED: 'CREATED',

    values: () => {
        return ['VALIDATE', 'CREATED'];
    }
}